export const DEFAULT_TELEMETRY_TAB_ID = "telemetry";
export const TIME_SERIE_TAB_PREFIX = "timeserie";
export const CNES_COMMAND_TAB_PREFIX = "cnescommand";
export const TELEMETRY_TABS_HEIGHT = 56;